import {
  // Fade,
  Popover as MuiPopover,
  // useMediaQuery,
} from '@mui/material';
import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
import useStyles from './PopoverStyles';

export const Popover = ({
  isOpen,
  onClose,
  anchorEl,
  children,
  style,
  anchorOrigin,
  transformOrigin,
  innerStyle,
  innerProps,
}) => {
  const classes = useStyles();
  // const breakpointXsDown = useMediaQuery(muiTheme.breakpoints.down("xs"));

  useEffect(() => {
    if (isOpen && !anchorEl) {
      console.warn('Anchor is missing from popover. This is likely a mistake.');
    }
  }, [anchorEl, isOpen]);

  // Optimisation to prevent rendering before opened for first time
  const [hasOpened, setHasOpened] = useState(isOpen);

  useEffect(() => {
    if (isOpen) {
      setHasOpened(true);
    }
  }, [isOpen]);

  if (!hasOpened) {
    return <></>;
  }

  return (
    <MuiPopover
      anchorEl={anchorEl}
      keepMounted={false}
      open={isOpen}
      onClose={onClose}
      className={classes.popover}
      anchorOrigin={anchorOrigin}
      transformOrigin={transformOrigin}
      style={{ ...style }}
      // disableScrollLock
      PaperProps={{
        style: {
          marginTop: '24px',
          // position: 'absolute',
          padding: '16px',
          // top: '25px',
          // left: '10px',
          boxShadow: '0px 4px 14px rgba(111, 111, 111, 0.25)',
          borderRadius: '18px',
          ...innerStyle,
        },
      }}
      // TransitionComponent={Fade}
      // TransitionProps={{ timeout: 0 }}
      {...innerProps}
    >
      {children}
    </MuiPopover>
  );
};

Popover.defaultProps = {
  style: {},
  anchorOrigin: {
    vertical: 'bottom',
    horizontal: 'left',
  },
  transformOrigin: {
    vertical: 'top',
    horizontal: 'left',
  },
  innerStyle: {},
  innerProps: {},
  anchorEl: null,
  children: null,
};

Popover.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  style: PropTypes.shape({}),
  anchorEl: PropTypes.shape({}),
  children: PropTypes.element,
  anchorOrigin: PropTypes.shape({}),
  transformOrigin: PropTypes.shape({}),
  innerStyle: PropTypes.shape({}),
  innerProps: PropTypes.shape({}),
};
